/**
 * Copyright © Veeam Software Group GmbH.
 */

export const PERIOD_OPTIONS = [
    { id: 7, text: 'Last 7 Days' },
    { id: 30, text: 'Last 30 Days' },
];
